import { render, staticRenderFns } from "./StyleExample.vue?vue&type=template&id=15063108&scoped=true"
import script from "./StyleExample.vue?vue&type=script&lang=js"
export * from "./StyleExample.vue?vue&type=script&lang=js"
import style0 from "./StyleExample.vue?vue&type=style&index=0&id=15063108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15063108",
  null
  
)

export default component.exports